<a class="dropdown-item" routerLink="/alarmes/{{ this.alarm.idTipusAlarma }}">{{this.alarm.tipusAlarma}}&ngsp;<span class="badge badge-danger">{{this.alarm.count}}</span></a>
